import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import tImg from '../../images//team/61_result.webp'
import axios from 'axios';
import { useSeo } from '../../hooks/useSeo';
import facebook from "../../images/icons/facebook.webp";
import instagram from "../../images/icons/instagram.webp";
import linkedin from "../../images/icons/linkedin.webp";
import x from "../../images/icons/twitter.webp";

const staticMeta = {
  title: 'Our Team | RashTech Info',
  description: 'Meet the dedicated experts at RashTech Info driving innovation and delivering solutions across design, development, and strategy.',
  url: 'https://rashtechinfo.com/team',
  image: 'https://rashtechinfo.com/og-image.png',
  siteName: 'RashTech Info',
  keywords: 'team, experts, developers, designers, engineers, RashTech Info',
  themeColor: '#0A0D1C',
};

const TeamPage = () => {
  const [teams, setTeams] = useState([]);

  const { seo } = useSeo('/getSeo');

  const computed = useMemo(() => {
    const dynamic = {
      title: seo?.title,
      description: seo?.metaDescription,
      keywords: seo?.metaKeywords,
      canonicalUrl: seo?.canonicalUrl,
    };
    return {
      title: dynamic.title || staticMeta.title,
      description: dynamic.description || staticMeta.description,
      keywords: dynamic.keywords || staticMeta.keywords,
      url: dynamic.canonicalUrl || staticMeta.url,
      image: staticMeta.image,
      siteName: staticMeta.siteName,
      themeColor: staticMeta.themeColor,
    };
  }, [seo]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(`https://api.rashtechinfo.com/activeTeam`)
        setTeams(response.data.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchBlogs();
  }, []);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  }

  return (
    <Fragment>
      <Helmet>
        <title>{computed.title}</title>
        <meta name="description" content={computed.description} />
        {computed.keywords && <meta name="keywords" content={computed.keywords} />}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content={computed.themeColor} />
        {computed.url && <link rel="canonical" href={computed.url} />}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={computed.siteName} />
        <meta property="og:title" content={computed.title} />
        <meta property="og:description" content={computed.description} />
        {computed.url && <meta property="og:url" content={computed.url} />}
        {computed.image && <meta property="og:image" content={computed.image} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={computed.title} />
        <meta name="twitter:description" content={computed.description} />
        {computed.image && <meta name="twitter:image" content={computed.image} />}
      </Helmet>

      <Header />
      <main className="page_content about-page">
        <PageTitle pageTitle={'Team Member'} pagesub={'Members'} pageTop={'Team'} />
        <section className="about_section section_space bg-light">
          <div className="container">
            <div className="row align-items-center justify-content-lg-between">
              <div className="col-lg-6 order-lg-last">
                <div className="team_cartoon_image">
                  <img src={tImg} alt="Team Cartoon" />
                </div>
              </div>
              <div className="col-lg-5">
                <div className="about_content">
                  <div className="heading_block">
                    <div className="heading_focus_text">
                      Our Dedicated
                      <span className="badge bg-secondary text-white">Team </span>
                    </div>
                    <h2 className="heading_text">
                      Get to Know Our Expert RashTech Team
                    </h2>
                    <p className="heading_description mb-0">
                      Get acquainted with the powerhouse behind RashTech – our expert team of professionals dedicated to revolutionizing the IT landscape. Comprising.
                    </p>
                    
                  </div>
                  <Link onClick={ClickHandler} to={'/contact'} className="btn">
                    <span className="btn_label" data-text="Talk to an Expart">Talk to an Expart</span>
                    <span className="btn_icon">
                      <i className="fa-solid fa-arrow-up-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="team_section section_space">
          <div className="container">
            <div className="heading_block text-center">
              <div className="heading_focus_text">
                <span className="badge bg-secondary text-white">Our Expert</span>
                Team Members
              </div>
              <h2 className="heading_text mb-0">
                Top Skilled Experts
              </h2>
            </div>

            <div className="row">
              {teams.slice(0, 6).map((team, tm) => (
                <div className="col-lg-4 col-md-6 col-sm-6" key={tm}>
                  <div className="team_block">
                    <div className="team_member_image">
                      <span onClick={ClickHandler} className="image_wrap" aria-label="Team Details Button">
                        <img src={`https://api.rashtechinfo.com/uploads/${team.image}`} alt="" />
                      </span>
                    </div>
                    <div className="team_member_info">
                      <h3 className="team_member_name">
                        <span onClick={ClickHandler}>{team.name}</span>
                      </h3>
                      <h4 className="team_member_designation">{team.designation}</h4>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  )
};
export default TeamPage;
